import { render, staticRenderFns } from "./FileImage.vue?vue&type=template&id=761d3f03&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FileImage.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FileImage.vue
// module id = 2396
// module chunks = 1